const safeEnvVar = (val, fallback = '') => {
  return typeof window !== 'undefined'
    ? (window.env && window.env[val]) || fallback
    : process.env[val] || fallback;
};

export const BLUECONIC_CONTENT_COLLECTOR_ID: string | null = safeEnvVar(
  'BLUECONIC_CONTENT_COLLECTOR_ID'
);
// When 'rubyllm', Deep Research runs through the in-Rails ruby_llm + ti-mcp
// engine (synchronous /api/v1/ai_threads/:id/run) instead of the LangGraph
// streaming proxy. Anything else (incl. unset) keeps the LangGraph path.
export const DEEP_RESEARCH_ENGINE: string | null = safeEnvVar('DEEP_RESEARCH_ENGINE');
// When 'true' (preview/review apps only), the Deep Research UI shows a model
// switcher and sends the picked model with each run. The backend independently
// gates and whitelists, so this flag is presentational.
export const DEEP_RESEARCH_MODEL_SWITCHER: string | null = safeEnvVar(
  'DEEP_RESEARCH_MODEL_SWITCHER'
);
export const GOOGLE_CLIENT_ID: string | null = safeEnvVar('GOOGLE_CLIENT_ID');
console.log(
  '[OneTap] env.ts loaded. GOOGLE_CLIENT_ID:',
  GOOGLE_CLIENT_ID ? `set (${GOOGLE_CLIENT_ID.slice(0, 12)}...)` : 'MISSING/EMPTY'
);
export const IMGIX_ENV: string | null = safeEnvVar('IMGIX_ENV', safeEnvVar('RAILS_ENV'));
export const IMGIX_URL: string | null = safeEnvVar('IMGIX_URL');
export const RAILS_ENV: string | null = safeEnvVar('RAILS_ENV');
export const READ_ONLY_MODE: string | null = safeEnvVar('READ_ONLY_MODE');
export const READ_ONLY_PHRASE: string | null = safeEnvVar('READ_ONLY_PHRASE');
export const READER_URL: string | null = safeEnvVar('READER_URL');
export const READER_URL_PRODUCTION: string | null = safeEnvVar('READER_URL_PRODUCTION');
export const RECAPTCHA_SITE_KEY: string = safeEnvVar('RECAPTCHA_SITE_KEY');
export const CLOUDFLARE_SITE_KEY: string = safeEnvVar('CLOUDFLARE_SITE_KEY');
export const SHOW_MODAL_ON_INACTION_SECONDS: number = parseInt(
  safeEnvVar('SHOW_MODAL_ON_INACTION_SECONDS', '31000')
);
export const STRIPE_PUBLISH_KEY: string | null = safeEnvVar('STRIPE_PUBLISH_KEY');
export const SUBSCRIPTIONS_URL: string | null = safeEnvVar('SUBSCRIPTIONS_URL');
export const TRINITY_PLAYER_API_KEY: string | null = safeEnvVar('TRINITY_PLAYER_API_KEY');
